module.exports = __webpack_public_path__ + "img/q_14_sor.a9592608.png";